<template>
  <div class="water-form-comtainer">
    <div class="section-title">
      Summary of Two-Week Water Demand versus Water Storage Capacity
    </div>
    <div class="card">
      <div class="card-content">
        <div class="row no-margins">
          <div class="col s12">
            <div class="input-title left">Total Two-week Water Demand</div>
            <div class="label-value right">
              <div class="field-holder">
                <input type="number"
                  :value="parseFloat(waterHazardSurvey && waterHazardSurvey.survey.nonEssential ? waterHazardSurvey.survey.nonEssential.subTotal : 0) + parseFloat(essentialSubTotalX)" />
              </div>
              <!-- {{
                parseFloat(waterHazardSurvey.survey.nonEssential ?  waterHazardSurvey.survey.nonEssential.subTotal : 0 ) +
                parseFloat(essentialSubTotalX)
              }}
              Gallons -->
            </div>
          </div>
          <div class="clear"></div>
          <div class="col s12 details">
            <div class="label-item left">&bull; Essential household needs</div>
            <div class="label-value right">{{ essentialSubTotalX }} Gallons</div>
          </div>
          <div class="col s12 details">
            <div class="label-item left">&bull; Non-essential household needs</div>
            <div class="label-value right" v-if="waterHazardSurvey">{{ waterHazardSurvey.survey.nonEssential ?
              waterHazardSurvey.survey.nonEssential.subTotal : 0 }} Gallons</div>
          </div>
        </div>

        <div class="row no-margins">
          <div class="col s12">
            <div class="custom-total left">
              <div class=" input-title">Total Water Storage Capacity</div>
              Enter the total capacity/volume of the water
              storage tank(s) and/or cistern(s) at your home.
              If you do not know the volume, enter the
              measurements of your water tank(s) or
              cistern(s) below and the number of each size
              and the App will calculate the total volume for
            </div>
            <div class="total-value">
              <!--   <span>Total</span> -->
              <div class="field-holder">
                <input type="number" name="currentWaterSupply" id="currentWaterSupply" v-model="totalWaterStorageX" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "waterSupply",
  data() {
    return {
      totalWaterStorage: 0,
    };
  },
  computed: {
    ...mapState({
      showTour: (state) => state.Surveys.showSurveyTour,
      waterHazardSurvey: (state) => state.Surveys.waterHazard,
      waterHazardStarted: (state) => state.Surveys.waterHazardStarted,
      user: (state) => state.User.user,
    }),
    userRole: {
      get() {
        return 'subscriber'
        return this.user && this.user.roles.length > 0
          ? this.user.roles[0]
          : false
      }
    },
    essentialSubTotalX: {
      get() {
        if (this.waterHazardSurvey) {
          if (this.waterHazardSurvey.isNonStandard) {
            return parseFloat(this.waterHazardSurvey.survey.manualEssential.subTotal).toFixed(2);
          }
          return this.waterHazardSurvey.survey.essential ? parseFloat(this.waterHazardSurvey.survey.essential.subTotal).toFixed(2) : 0;
        }
        return 0;
      },
    },
    totalWaterStorageX: {
      get() {
        if (!this.waterHazardSurvey) return 0;
        return this.waterHazardSurvey.totalWaterStorage;
      },
      set(val) {
        this.totalWaterStorage = val ? parseFloat(val).toFixed(2) : 0;
        this.$emit("update", this.totalWaterStorage);
      },
    },
  },

  watch: {
    // totalWaterStorage(nV) {
    //   this.$emit("update", parseFloat(nV || 0).toFixed(2));
    // },
  },
  mounted() {
    this.totalWaterStorage = this.waterHazardSurvey.totalWaterStorage || 0;
  },
};
</script>
<style scoped lang="scss">
.water-form-comtainer {
  padding: 16px;
  max-width: 768px;
  margin: auto;

  .card {
    .card-title {
      font-size: 18px;
    }

    .input-title {
      font-size: 20px;
      line-height: 1.5;
    }

    .label-item {
      font-size: 17px;
      margin-bottom: 8px;
      color: #5374f8;
    }

    .label-value {
      font-size: 16px;
      font-size: 14px;
      margin-bottom: 8px;
    }

    .details {
      display: flow-root;
      margin-bottom: 12px;
      padding: 6px 12px 6px;
      position: relative;

      &::after {
        content: " ";
        position: absolute;
        bottom: 2px;
        height: 1px;
        background: #c7c7c7;
        left: 12px;
        width: calc(100% - 24px);
      }
    }
  }

  .total-value {
    span {
      font-size: 18px;
      color: #5374f8;
    }
  }

  .field-holder {
    width: 220px;
    border: 1px solid #cccccc;
    border-radius: 7px;
    position: relative;
    float: right;

    input[type="number"] {
      width: 116px;
      margin: 0px;
      border: none;
      background: #f5f5f5;
      border-radius: 6px 0 0 6px;
    }

    &::after {
      content: "Gallons";
      position: absolute;
      right: 10px;
      top: 13px;
      color: #525252;
      letter-spacing: 1px;
      font-size: 13px;
      font-weight: 500;
    }
  }

  .section-title {
    font-size: 24px;
    width: 90%;
    padding-left: 5px;
    margin-bottom: 12px;
  }
}
</style>
